import styled from "styled-components";

export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	z-index: 1060;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 16px;
	background-color: rgba(0, 0, 0, 0.45);
`;

export const Card = styled.div`
	position: relative;
	width: 100%;
	max-width: 1000px;
	max-height: calc(100vh - 32px);
	overflow-y: auto;
	background: #ffffff;
	border-radius: 8px;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
	padding: 40px 40px 32px;
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 14px;
	right: 14px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background: transparent;
	border: 0;
	cursor: pointer;
	outline: 0;
	padding: 4px;
	line-height: 0;

	&:focus-visible {
		outline: 2px solid var(--secondary-border-color);
		outline-offset: 2px;
	}
`;

export const Title = styled.h2`
	margin: 0;
	font: normal normal 600 24px/32px Lato;
	color: #181c1e;
	text-align: center;
`;

export const Subtitle = styled.p`
	margin: 12px 0 0;
	font: normal normal normal 16px/24px Lato;
	color: #464652;
	text-align: center;
`;

export const FormGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 24px 40px;
	margin-top: 32px;

	@media (min-width: 768px) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
`;

export const Actions = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	margin-top: 32px;
	flex-wrap: wrap;
`;
